/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
import 'core-js/es6';
import 'core-js/es7/reflect';
import 'core-js/es7/array.js';
import './zone-flags';
import 'zone.js';


if (!Element.prototype.matches) {
  Element.prototype.matches =
    (<any>Element.prototype).msMatchesSelector ||
    Element.prototype.webkitMatchesSelector ||
    function(s) {
      let matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {/**/}
      return i > -1;
    };
}
